var path = 'public/app/features/dashboard/partials/folder_permissions.html';
var html = "<page-header model=ctrl.navModel></page-header>\n\n<div class=\"page-container page-body\">\n  <dashboard-permissions ng-if=\"ctrl.dashboard && ctrl.meta\" dashboardid=ctrl.dashboard.id />\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;